<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <!-- {{ this.ferg() }} -->
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">EDITAR ROL</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="name"
                      v-model="data.name"
                      :rules="nameRules"
                      label="Nombre"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="company"
                      v-model="data.company"
                      :items="itemsData"
                      :search-input.sync="search"
                      item-value="_id"
                      item-text="name"
                      label="Empresas"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
                      clearable
                      :rules="fieldRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="activate"
                      v-model="data.activate"
                      :items="[1, 0]"
                      label="Estado"
                      :rules="fieldRules"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item == 1 ? "Activo" : "Inactivo" }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        {{ item == 1 ? "Activo" : "Inactivo" }}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <!-- {{ item }} -->
                    <v-checkbox
                      class="checkbox_inline"
                      v-for="(el, i) in arrayModule"
                      :key="i"
                      v-model="data._modules"
                      :value="el"
                      :label="`${el.nameModule}`"
                    ></v-checkbox>
                    <div v-if="isMaster == 1">
                      <p class="title_master"><b>SOLO CUENTA MASTER</b></p>
                      <v-checkbox
                        class="checkbox_inline"
                        v-for="(el, index) in arrayMaster"
                        :key="index"
                        v-model="data._modules"
                        :value="el"
                        :label="`${el.nameModule}`"
                      ></v-checkbox>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >GUARDAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "RolEditComp",
  components: {},
  props: ["visible", "data"],
  data() {
    return {
      valid: true,
      form: {
        _modules: [],
      },
      arrayMaster: [
        {
          _id: "60f82a6fe85533f80b09cda3",
          visible: false,
          nameModule: "Master",
          icon: "mdi-guy-fawkes-mask",
          route: "PanelHome",
          checkModule: true,
        },
        {
          _id: "60f82a5b04e7e3fa881d977e",
          visible: true,
          checkModule: true,
          nameModule: "Estacion",
          icon: "mdi-server",
          route: "StationHome",
        },
        {
          _id: "60f82a4995deefa01843fb98",
          visible: true,
          checkModule: true,
          nameModule: "Empresas",
          icon: "mdi-office-building",
          route: "CompanyHome",
        },
      ],
      arrayModule: [
        {
          _id: "60f828ae31c01649764595c9",
          visible: true,
          checkModule: true,
          nameModule: "Dispositivos",
          icon: "mdi-chip",
          route: "DeviceHome",
        },
        {
          _id: "61245e0184623aa87b7f7995",
          visible: true,
          checkModule: true,
          nameModule: "Redes",
          icon: "mdi-vector-triangle",
          route: "NetworkHome",
        },
        {
          _id: "60f829a153432409cc9816d9",
          visible: false,
          checkModule: true,
          nameModule: "Ruta",
          icon: "mdi-chip",
          route: "DeviceHome",
        },
        {
          _id: "60f829c23c0cf6085380874d",
          visible: false,
          checkModule: true,
          nameModule: "Ciclos",
        },
        {
          _id: "60f829ce37f8322f09fa2014",
          visible: false,
          checkModule: true,
          nameModule: "Estrato",
        },
        {
          _id: "60f829de1f2513496374a9a3",
          visible: false,
          checkModule: true,
          nameModule: "Zona",
        },
        {
          _id: '62c86946715b05c3c3decd45',
          visible: false,
          checkModule: true,
          nameModule: 'Periodo',
        },
        {
          _id: '60f829f465d73948bbfcfd2b',
          visible: true,
          checkModule: true,
          nameModule: "Reportes",
          icon: "mdi-file-table",
          route: "ReportHome",
        },
        {
          _id: "60f82a12f46a4253a3562884",
          visible: true,
          checkModule: true,
          nameModule: "Usuarios",
          icon: "mdi-account",
          route: "UserHome",
        },
        {
          _id: "60f82a1f525377733bcb1284",
          visible: true,
          checkModule: true,
          nameModule: "Roles",
          icon: "mdi-shield-account",
          route: "RolHome",
        },
        {
          _id: "60f82a2c90111778876bf740",
          visible: true,
          checkModule: true,
          nameModule: "Configuracion",
          icon: "mdi-tune-vertical",
          route: "ConfigHome",
        },
        {
          _id: "60f82a3bbc746ae370b3174c",
          visible: false,
          checkModule: true,
          nameModule: "Suscriptor",
          icon: "mdi-account",
          route: "SuscriptorHome",
        },
      ],
      arrayCompany: null,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => v != null || "El campo es requerido"],
      search: "",
      itemsData: [],
      totalItems: 0,
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
    await this.getJsonData();
  },
  watch: {
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["updateRol", "alertSnackbar"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)

          axios
            .get(
              `company/list?page=${this.pagination.page}&search=${this.search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
          name: this.data.name,
          company: this.data.company,
          state: this.data.state,
          activate: this.data.activate,
          _modules: this.form._modules,
        };
        if (this.form._modules.length > 0) {
          form._modules = this.form._modules;
        } else {
          form._modules = this.data._modules;
        }
        let update = await this.updateRol(form);
        this.$refs.form.reset();
        if (update == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "El rol se ha actualizado.",
          });
          this.$root.$emit("reload"); // parametro update tabla
        }
        this.show = false;
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getListCompany", "isMaster"]),
    filterDataCheck() {
      let filter = this.data._modules.map((item) => {
        return {
          visible: item.visible,
          nameModule: item.nameModule,
          route: item.route,
          icon: item.icon,
        };
      });
      return filter;
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
